import apiClient from '../apiClient';
import { GET_USER_NOT_EMPL0YEE_URL } from '../apiUrl';

const getUserNotEmployeeApi = () => {
  return apiClient.get(GET_USER_NOT_EMPL0YEE_URL);
};

export default getUserNotEmployeeApi;
